import React from "react";
import { ArrowDownRight, X } from "lucide-react";
import DashboardPortalTooltip from "./DashboardPortalTooltip";

export default function DashboardKpiSection({
  visibleWidgets,
  isMobile,
  isEditMode,
  longPressHandlers,
  DashboardCard,
  totalStudents,
  avgAttendance,
  birthdayCount,
  remainingBudget,
  level,
  earnedBadgesCount,
  icons,
  attStatus,
  birthStatus,
  budgetStatus,
  onNavigate,
  onOpenProfile,
  isLongPressTriggered,
  deleteWidget,
}) {
  return ["students", "attendance", "birthday", "budget", "growth"].filter((id) => visibleWidgets[id]).map((id) => {
    let cardContent = null;
    const cardProps = { isEditMode, isMobile };

    if (id === "students") {
      cardContent = (
        <DashboardCard
          {...longPressHandlers}
          {...cardProps}
          title="등록 학생"
          value={`${totalStudents}명`}
          mainIcon={icons.student}
          subInfoIcon={icons.check}
          subInfoText="이번 달 현황"
          bgColor="bg-blue-400"
          onClick={(e) => {
            if (isEditMode || isLongPressTriggered()) {
              e.stopPropagation();
              return;
            }
            onNavigate("students");
          }}
        />
      );
    }

    if (id === "attendance") {
      cardContent = (
        <DashboardCard
          {...longPressHandlers}
          {...cardProps}
          title="출결 현황"
          value={`${avgAttendance}%`}
          mainIcon={icons.attendance}
          subInfoIcon={attStatus.icon}
          subInfoText={attStatus.text}
          bgColor="bg-green-400"
          onClick={(e) => {
            if (isEditMode || isLongPressTriggered()) {
              e.stopPropagation();
              return;
            }
            onNavigate("attendance");
          }}
        />
      );
    }

    if (id === "birthday") {
      cardContent = (
        <DashboardCard
          {...longPressHandlers}
          {...cardProps}
          title="이번달 생일"
          value={`${birthdayCount}명`}
          mainIcon={icons.party}
          subInfoIcon={birthStatus.icon}
          subInfoText={birthStatus.text}
          bgColor="bg-yellow-400"
          onClick={(e) => {
            if (isEditMode || isLongPressTriggered()) {
              e.stopPropagation();
              return;
            }
            onNavigate("students");
          }}
        />
      );
    }

    if (id === "budget") {
      cardContent = (
        <DashboardCard
          {...longPressHandlers}
          {...cardProps}
          title={
            <span>
              남은 예산 <DashboardPortalTooltip text="연간 예산 - 올해 누적 지출" />
            </span>
          }
          value={`${(remainingBudget / 10000).toFixed(0)}만`}
          mainIcon={icons.money}
          subInfoIcon={budgetStatus.icon}
          subInfoText={budgetStatus.text}
          bgColor="bg-red-400"
          onClick={(e) => {
            if (isEditMode || isLongPressTriggered()) {
              e.stopPropagation();
              return;
            }
            onNavigate("finance");
          }}
        />
      );
    }

    if (id === "growth") {
      cardContent = (
        <DashboardCard
          {...longPressHandlers}
          {...cardProps}
          title="사역 여정"
          value={`Lv.${level}`}
          mainIcon="/images/Trophy.png"
          subInfoIcon="/images/Star.png"
          subInfoText={`${earnedBadgesCount}개 배지`}
          bgColor="bg-amber-400"
          onClick={(e) => {
            if (isEditMode || isLongPressTriggered()) {
              e.stopPropagation();
              return;
            }
            if (onOpenProfile) onOpenProfile();
          }}
        />
      );
    }

    return (
      <div key={id} className={`${isMobile ? "min-w-[120px] snap-start" : "h-full"}`}>
        <div
          className={`h-full ${isEditMode ? "animate-shake ring-4 ring-blue-400/50 rounded-[2.5rem] relative z-40" : ""}`}
          style={{ height: "100%", animationDelay: isEditMode ? `${Math.random() * -0.5}s` : "0s" }}
        >
          {cardContent}
          {isEditMode && !isMobile && (
            <>
              <button
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.stopPropagation();
                  deleteWidget(id);
                }}
                className="non-draggable absolute -top-2 -right-2 bg-red-500 text-white p-1.5 rounded-full shadow-lg hover:scale-110 transition z-50 cursor-pointer"
              >
                <X size={16} />
              </button>
              <div
                className="react-resizable-handle react-resizable-handle-se absolute bottom-8 right-2 w-8 h-8 bg-white/30 backdrop-blur-md border border-white/60 text-[#2C3E30] rounded-full shadow-lg flex items-center justify-center cursor-se-resize z-50 hover:scale-110 hover:bg-white/50 transition-all"
                style={{ touchAction: "none" }}
                onClick={(e) => e.stopPropagation()}
              >
                <ArrowDownRight size={18} strokeWidth={3} />
              </div>
            </>
          )}
        </div>
      </div>
    );
  });
}
